/**
 * Schema of StatusCarga
 * @author Simpli CLI generator
 */
import {InputType, Schema} from 'simpli-web-sdk'
import {bool} from 'simpli-web-sdk'
import StatusCarga from '@/model/resource/StatusCarga'

export default (model: StatusCarga): Schema => ({
  idStatusPk: {
    content: model.idStatusPk,
    editable: false,
  },

  nome: {
    content: model.nome,
    input: InputType.TEXT,
    meta: {
      required: true,
      maxlength: '255',
    },
  },

  ativo: {
    content: bool(model.ativo),
    hidden: true,
    editable: false,
  },
})
